<template>
  <card-seplag titulo="Recadastros" cor="#00acc1" >  
      <div class="filter-container p-grid p-fluid p-col-12">
        <Rotulo nome="BUSCAR USUÁRIO" cols="12 4">
          <InputText
            class="classe-input"
            type="text"
            placeholder="Insira uma matrícula, nome ou CPF"
            v-model="pesquisa"
            @keyup.enter="listarCadastros()"
          />
        </Rotulo>
        <Rotulo nome="Ciclos" cols="12 4">
          <Dropdown 
            :options="ciclos" 
            optionLabel="descCiclo" 
            dataKey="idenCiclo" 
            optionValue="idenCiclo" 
            showClear
            v-model="idenCicloState"
          />
        </Rotulo>
        <Rotulo cols="12 4">
          <Button
            icon="pi pi-search"
            label="Pesquisar"
            class="classe-button"
            @click="listarCadastros()"
          />
        </Rotulo>
      </div>
        <table-seplag
        :dados.sync="listRecadastros"
        :totalRegistro.sync="totalRegistro"
        :campos="colunas" 
        :paginacao="true"
        :onSearchPaginacao="paginacao"
        :linhas="linha"
        cols="12" >
            <Column headerStyle="width: 9em;" class="p-grid" >
                <template #body="linha" >
                    <Button  icon="pi pi-eye" class="p-button-rounded p-button-success" @click="visualizar(linha.data)"/>
                </template>
            </Column>
        </table-seplag>
    </card-seplag>  
</template>

<script>
import CardSeplag from '@/template/CardSeplag.vue'
import TableSeplag from '@/template/TableSeplag.vue'
import { baseApiUrl   } from '@/config/global';
import Rotulo from "@/template/RotuloSeplag.vue";

export default {
    components: {CardSeplag, TableSeplag,Rotulo},
    name:"listar-recadastros",
    data: ()=>({
      pesquisa:"",
      idenCicloState:null,
      linha:0,
      listRecadastros:[],
      totalRegistro:0,
      colunas:[
        {
          nome: "matricula",
          titulo: "Matrícula",
          alinhamento: "left",
          },
          {
            nome: "cpf",
            titulo: "CPF",
            alinhamento: "left",
          },
        {
          nome: "servidor",
          titulo: "Servidor",
          alinhamento: "left",
        },
        {
          nome: "descCiclo",
          titulo: "Ciclo",
          alinhamento: "left",
        },
      ],
      ciclos:[]
    }),
    mounted(){
      this.carregarDados()
    },
    methods:{
      async carregarDados(){
        this.$http.get(`${baseApiUrl}/ciclos/all`).then(res =>{
          this.ciclos= res.data;
        }) 
        this.paginacao()
      },
      visualizar(dados){
        this.$router.push({name: "RECADVIEW_DADOS_PESSOAIS_VIEW", params: { id: dados.idenCicloPessoa }})
      },
      listarCadastros(){
        this.paginacao(10,0,this.pesquisa,this.idenCicloState || 0)
      },
      paginacao(rows=10,page=0,pesquisa="",idenCiclo=0){     
        let urlPaginacao = `ciclopessoas/busca`
          this.$http.get(`${baseApiUrl}/${urlPaginacao}?size=${rows}&page=${page}&pesquisa=${pesquisa}&idenCiclo=${idenCiclo}`).then(res =>{
                  this.listRecadastros = res.data.content
                  this.totalRegistro = res.data.totalElements
                  this.linha = rows
          }) 
      }
    }
  }
</script>


<style scoped>
.filter-container {
  align-items: stretch;
  margin-top: 2rem;
  margin-bottom: 1rem;
  align-items: flex-end;
}

</style>